import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, gbp } from "@/lib/api";

const STATUS_OPTIONS = ["", "awaiting_payment", "payment_processing", "confirmed", "in_preparation", "ready_for_collection", "out_for_delivery", "completed", "cancelled", "requires_attention"];
const STATUS_COLOURS = {
  awaiting_payment: "text-amber-300", payment_processing: "text-amber-300", confirmed: "text-green-400",
  in_preparation: "text-blue-300", ready_for_collection: "text-gold", out_for_delivery: "text-gold",
  completed: "text-cream-muted", cancelled: "text-red-400", requires_attention: "text-red-300",
};

export default function AdminOrders() {
  const [orders, setOrders] = useState(null);
  const [status, setStatus] = useState("");
  const [q, setQ] = useState("");

  const load = () => {
    const params = {};
    if (status) params.status = status;
    if (q) params.q = q;
    api.get("/admin/orders", { params }).then((r) => setOrders(r.data));
  };
  useEffect(() => { load(); }, [status]);

  return (
    <div data-testid="admin-orders-page">
      <h1 className="font-serif text-2xl font-bold text-cream-text">Orders</h1>

      <div className="mt-5 flex flex-wrap gap-3">
        <input
          value={q}
          onChange={(e) => setQ(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && load()}
          placeholder="Search order no, name, email…"
          className="w-64 rounded-xl border border-choco-line bg-choco px-4 py-2 text-sm text-cream-text placeholder:text-cream-muted/60 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold-focus"
          data-testid="orders-search-input"
        />
        <button onClick={load} className="rounded-full border border-choco-line px-4 py-2 text-xs font-bold text-cream-text hover:border-gold hover:text-gold" data-testid="orders-search-button">Search</button>
      </div>

      <div className="mt-4 flex flex-wrap gap-2" data-testid="orders-status-filters">
        {STATUS_OPTIONS.map((s) => (
          <button
            key={s || "all"}
            onClick={() => setStatus(s)}
            className={`rounded-full px-3.5 py-1.5 text-xs font-bold capitalize ${status === s ? "bg-gold text-choco" : "border border-choco-line text-cream-muted hover:text-gold"}`}
            data-testid={`orders-filter-${s || "all"}`}
          >
            {(s || "all").replace(/_/g, " ")}
          </button>
        ))}
      </div>

      <div className="mt-6 space-y-3" data-testid="orders-list">
        {orders === null && <p className="text-sm text-cream-muted">Loading…</p>}
        {orders?.length === 0 && (
          <p className="rounded-3xl border border-choco-line bg-choco-light p-8 text-center text-sm text-cream-muted" data-testid="orders-empty">No orders yet.</p>
        )}
        {orders?.map((o) => (
          <Link
            key={o.id}
            to={`/admin/orders/${o.id}`}
            className="flex flex-wrap items-center justify-between gap-3 rounded-2xl border border-choco-line bg-choco-light p-4 transition-colors hover:border-gold/50"
            data-testid={`order-row-${o.order_number}`}
          >
            <div>
              <p className="font-semibold text-cream-text">{o.order_number} <span className="ml-2 text-xs font-normal text-cream-muted">{o.customer?.name}</span></p>
              <p className="mt-0.5 text-xs text-cream-muted">
                {o.fulfilment_method}{o.slot_snapshot ? ` · ${o.slot_snapshot.date} ${o.slot_snapshot.start_time}` : ""} · {gbp(o.total_pence)}
              </p>
            </div>
            <div className="flex items-center gap-3">
              {o.payment_status === "unpaid_on_collection" && (
                <span className="rounded-full bg-amber-500/20 px-2.5 py-0.5 text-[11px] font-bold text-amber-300">Collect {gbp(o.total_pence)}</span>
              )}
              <span className={`text-xs font-bold capitalize ${STATUS_COLOURS[o.order_status] || ""}`} data-testid={`order-status-${o.order_number}`}>
                {o.order_status.replace(/_/g, " ")}
              </span>
              <span className="text-xs capitalize text-cream-muted">{o.payment_status.replace(/_/g, " ")}</span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
